import Parallax from 'parallax-js';
import '~/js/modules/stickyNav';
import 'slick-carousel';
import '~/js/libs/swipeDetect';

const $slickSlider = $('.slide-wrap');
const settings = {
  dots: true,
  lazyLoad: 'ondemand',
  infinite: false
};

$slickSlider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
  const slidesLength = slick.$slides.length;

  if (nextSlide <= slidesLength - 2) {
    const nextSlide1 = $slickSlider.find(`div[data-slick-index='${nextSlide}']`).find('.image-background')[0];
    const nextNextSlide = $slickSlider.find(`div[data-slick-index='${nextSlide + 1}']`).find('.image-background')[0];

    const nextSlide1Image = $(nextSlide1).data('bg');
    const nextNextSlideImage = $(nextNextSlide).data('bg');

    nextSlide1.style.backgroundImage = `url(${nextSlide1Image})`;
    nextNextSlide.style.backgroundImage = `url(${nextNextSlideImage})`;
  }
});

$slickSlider.on('afterChange', (event, slick, currentSlide) => {
  if (currentSlide + 1 === slick.slideCount) {
    const activeSlide = $slickSlider.find('.slick-active').find('.image-background')[0];
    const activeSlideImg = $(activeSlide).data('bg');

    activeSlide.style.backgroundImage = `url(${activeSlideImg})`;
  }
});

$slickSlider.on('wheel', (e) => {
  e.preventDefault();

  if (e.originalEvent.deltaY > 25) {
    $slickSlider.slick('slickNext');
  }

  if (e.originalEvent.deltaY < -25) {
    $slickSlider.slick('slickPrev');
  }
});

$slickSlider.swipeDetector().on('swipeUp.sd swipeDown.sd', (e) => {
  if (window.innerWidth <= 1024) {
    if (e.type === 'swipeUp') {
      $slickSlider.slick('slickNext');
    }

    if (e.type === 'swipeDown') {
      $slickSlider.slick('slickPrev');
    }
  }
});

$slickSlider.slick(settings);

const scenes = Array.from(document.getElementsByClassName('scene'));

scenes.forEach(scene => {
  new Parallax(scene, {
    limitY: 0,
    invertX: false
  });
});
